import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { fileQueryKeys } from "./fileQueryKeys";

export function useDirectoryExtensions(
  directoryPath: string,
  datasetId: string,
  resourceOwnerId?: string,
) {
  const { files } = useDomainServices();

  return useQuery<string[], Error>({
    queryKey: fileQueryKeys.directoryExtensions({
      directoryPath,
      datasetId,
    }),
    queryFn: async ({ signal }) => {
      const extensions = await files.getExtensionsForDirectory(
        datasetId,
        directoryPath,
        {
          abortSignal: signal,
          resourceOwnerId,
        },
      );

      return extensions;
    },
  });
}
